import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/compare-bridebook-alternative";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/compare/bridebook-alternative")({
  head: SEO["/compare/bridebook-alternative"],
  component: () => <ContentPage path="/compare/bridebook-alternative" body={body} />,
});
